import React from "react";
import remove_icon from "../../assets/images/icon-remove.svg";
import Select from "react-select";
import useAuth from "../../hooks/useAuth";

export const SearchLabel: React.FC<any> = (props) => {
  const {
    client = [],
    clientList = [],
    handleClient,
  } = props.data;

  const { user } = useAuth() as any;


  return (
    <div className="search-component">
      <div className="container uk-container-large">
        {/* <div className="label title-label fw-bold mb-4">
          Which label are you looking for?
        </div> */}
        <div className="search-content row d-flex flex-row position-relative">
          <div className="col-md-10 search-item-title label title-label fw-bold">Labels</div>
          <div className="col-md-2 search-item">
            <div className="item-header">
              <div className="text-white item-title">Name</div>
              <div className="count-found">found {clientList.length}</div>
            </div>
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <Select
                className="select-search"
                options={
                  clientList?.map((item: any) => ({
                    value: item.id,
                    label: item.title
                  }))
                }
                onChange={(item: any) =>
                  {
                    if((user?.profile?.client_id===null&&+item.value===2)||(user?.profile?.client_id==+item.value)){
                      // handleClient(+item.value)
                    }else{
                      alert("Please contact Cugate Ltd. for access permissions.");
                    }                    
                  }
                }
                placeholder=""
                isSearchable={true}
              />
            </div>
            <div className="d-flex flex-row flex-wrap mt-2">
              {client?.map((item: any) => (
                <div
                  className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                  key={"client_" + item}
                  // onClick={() => handleClient(item)}
                >
                  <div className="me-2 title">{clientList.filter((c: any) => c.id === item).length ? clientList.filter((c: any) => c.id === item)[0].title : ''}</div>
                  {/* <img
                    alt="remove"
                    className="remove-selected"
                    src={remove_icon}
                  /> */}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchLabel;
